module.exports = __webpack_public_path__ + "media/country_flags/va-ecabb62d.png";